import { useState, useEffect } from 'react'

export function usePrefersReducedMotion() {
    const [prefersReduced, setPrefersReduced] = useState(() => {
        if (typeof window === 'undefined') return false
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches
    })

    useEffect(() => {
        const mql = window.matchMedia('(prefers-reduced-motion: reduce)')
        const handler = (e) => setPrefersReduced(e.matches)
        mql.addEventListener('change', handler)
        return () => mql.removeEventListener('change', handler)
    }, [])

    return prefersReduced
}
